const borderRadii = {
  default: "8px",
  medium: "4px",
  big: "8px",
  focusWell: "8px"
};

export { borderRadii };
